<template>
  <vs-tabs
    :position="isSmallerScreen ? 'top' : 'left'"
    class="tabs-shadow-none"
    id="profile-tabs"
    :key="isSmallerScreen"
  >
    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'Geral' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-general />
      </div>
    </vs-tab>

    <!-- CHANGE PASSWORD -->
    <vs-tab icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? 'Mudar Senha' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-change-password />
      </div>
    </vs-tab>
    <!-- TWO-STEP VERIFICATION -->
    <vs-tab icon-pack="feather" icon="icon-user-check" :label="!isSmallerScreen ? 'Verificação em Duas Etapas' : ''">
      <template #label>
        {{ !isSmallerScreen ? 'Verificação em Duas Etapas' : verifyActivity ? 'Ativada' : 'Desativada' }}
      </template>
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <vs-alert title="Atenção!" active="true" color="warning">
            Quer manter sua conta do pedbot mais segura? Ative a verificação em duas etapas.

            A verificação em duas etapas é um tipo de verificação extra, que integra sua conta do pedbot ao app do Google Authenticator!
          </vs-alert>
          <div class="flex flex-wrap justify-between my-5">
          <vs-checkbox v-model="verifyActivity" class="mb-3">Ativar Verificação em Duas Etapas</vs-checkbox>
          <div class="flex flex-wrap items-center justify-end">
            <vs-button
              class="ml-auto mt-2"
              color="rgb(62, 201, 214)"
              type="filled"
              @click.prevent="saveSettings"
            >Salvar</vs-button>
          </div>
        </div>
        <vs-popup
        title="Atenção! Faça corretamente a autenticação!"
        :active.sync="showModal"
        class="sizePopup"
        >
          <TwoFactorAuthSetup 
            @showModal="closePopup" 
            :verifyActivity="verifyActivity"
            @backToQrCode="showModal = true"
          />
        </vs-popup>
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
  import UserSettingsGeneral from "./UserSettingsGeneral.vue"
  import UserSettingsChangePassword from "./UserSettingsChangePassword.vue"
  import TwoFactorAuthSetup from "@/components/twoFactor/TwoFactorAuthSetup.vue"

  export default {
  components: {
    UserSettingsGeneral,
    UserSettingsChangePassword,
    TwoFactorAuthSetup
  },
  data() {
    return {
      verifyActivity: this.$store.state.AppActiveUser.twofactor_activity,
      showModal: false,
    };
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    }
  },
  watch: {
    '$store.state.AppActiveUser.twofactor_activity'(newValue) {
      this.verifyActivity = newValue;
    }
  },
  methods: {
    async saveSettings() {
      this.$vs.notify({
        title: 'Autenticação em 2 Fatores',
        text: 'Ação realizada com sucesso',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success',
      });
        if (this.verifyActivity !== true) {
          this.verifyActivity = false
          await this.$store.dispatch('user/twoFactorActivity', {validate: '', identify: 2, ip: ''})
        }
        if(this.verifyActivity){
            setTimeout(() => {
              this.showModal = true
            }, 500);
        }
    },
    closePopup(value){
      this.showModal = value
      this.$store.dispatch('user/infos')
    },
  },
  beforeRouteLeave(to, from, next) {
    this.showModal = false;
      this.$events.fire('closePopUpSetting');
      setTimeout( ()=> { next(); }, 500);
  },
  created() {
    this.closePopup()
  },
};
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }
</style>
